/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type AccountStatementLineStatus =
  typeof AccountStatementLineStatus[keyof typeof AccountStatementLineStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountStatementLineStatus = {
  NEW: 'NEW',
  PUBLISHED: 'PUBLISHED',
  IGNORED: 'IGNORED',
} as const;
